goog.provide("shadow.js.shim.module$react_dom$server");
goog.provide("module$shadow_js_shim_module$react_dom$server");
shadow.js.shim.module$react_dom$server = shadow.js.nativeProvides["react-dom/server"] = shadow$bridge("react-dom/server");
module$shadow_js_shim_module$react_dom$server.default = shadow.js.shim.module$react_dom$server;
